import Slider from '../util/Slider';
import OsmMap from '../util/OsmMap';
import LightBox from '../util/LightBox';
import UiConfig from '../util/UiConfig';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    new Slider();
    new OsmMap();
    new LightBox();
    new UiConfig();
    jQuery(document).on('scroll',function(){
      if(jQuery(this).scrollTop()>45){
        jQuery('header.banner').addClass('fixed');
      }
      else{
        jQuery('header.banner').removeClass('fixed');
      }
    })
    jQuery('.open-primary-menu').click(function(e){
      jQuery('.header-menu .nav-primary .nav').toggleClass('active')
      e.preventDefault()
    })
    jQuery('#newsletter form').submit(function(e){
      $.ajax({
        url: ajaxUrl,
        type: 'POST',
        data: $(this).serializeArray(),
        success: function(){
          $('#newsletter form').html('<div class="alert alert-success">Nous avons bien enregistré votre inscription à notre newsletter. Merci pour votre confiance</div>')
        },
        error: function(){
          $('#newsletter form').html('<div class="alert alert-danger">Une erreur innatendu s\'est produite et nous n\'avons pas pu enregistrer votre inscription.<br>Nous vous invitons à nous contacter directement ou à réessayer ultérieurement.</div>')
        },
      })
      $(this).html('<strong>Enregistrement ...</strong><br>Merci de patienter quelques secondes')
      e.preventDefault()
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js